export default __webpack_public_path__ + "static/media/img0.b2db9737.jpg";